import React from 'react'
import { MdArrowBackIosNew } from "react-icons/md";



function EidulAdha() {
  return (
    <div className='contain'>
        <div className="page-header">
          <span className="backBtn" onClick={()=> window.history.back()}>
            <MdArrowBackIosNew />
          </span>
          <div className="page-header__content">
            <h1 className="pagetitle">EID-UL-ADHA</h1>
          </div>
        </div>
            <h3 className="contentSection_subtitle">QURBAANI KA BAYAAN</h3>
            <p className="contentSection_title--content">
            Qurbaani Hazrat saiyyiduna ibaraheem عليه السلام ki sunnat hai jo is ummat ke liye baaqi rah gayi aur 
            Nabi صلى الله تعالى علي ه وسلم ko qurbaani karne ka hukm diya gaya irshad farmaya  ّفَصَل لِرَبِّكَ وَانْحَر‌ْ 
            Tum apne Rab ke liye namaz padho aur qurbaani karo.
            </p>
            <span className='referenceTag'>Surah Al-Kausar aayat no. 2</span>
            <h3 className="contentSection_subtitle">  AHAADEES E KAREEMA</h3>
          
            <p className="contentSection_title--content">
            (1) Ummul Mumineen Hazrat Aaishah siddiqa رضى الله تعالى عنها se riwayat hai ki Huzur-E-Aqdas 
            صلى الله تعالى عليه وسلم ne irshad farmaya ki: YaumunNahar (10vi zilHijjah) me ibn-E-Aadam ka koi
             amal khuda ke nazdeek khoon bahane ( qurbaani karne) se ziyadah pyaara nahi aur  woh jaanwar qiyaamat
              ke din apne sing aur baal aur khuron ke saath aayega aur qurbaani ka khoon zameen par girne se qabl 
              khuda ke nazdeek maqaam e qubool me pahunch jaata hai lihaza is ko khush dili se karo.
            </p>
            <span className='referenceTag'>Abu daaud / tirmizi / ibn e maajah</span>
            <p className="contentSection_title--content">
            Hazrat imam Hasan bin Ali رضى الله تعالى عنهما se riwayat hai keh Huzur صلى الله تعالى عليه وسلم 
            ne farmaya jis ne khushi se taalib e sawab ho kar qurbaani ki  woh aatish e jahannam se hijaab (rok) ho
             jaayegi (tibraani).
            </p>
            <p className="contentSection_title--content">
            Hazrat Abdullah bin Abbas رضى الله تعالى عنهما se riyawat hai keh Huzur صلى ا لله تعالى عليه وسلم ne
             irshad farmaya jo rupiya eid ke din q urbaani me kharch kiya gaya us se ziyadah koi rupiya piyara nahi
              ( tibraani).
            </p>
            <p className="contentSection_title--content">
            Hazrat e Abu Hurairah رضى الله تعالى عنه se riwayat hai keh Huzur-E-Aqdas صلى الله تعالى عليه وسلم 
            ne farmaya jis me us’at ho aur qurbani na kare  woh hamari eid gaah ke qareeb na aaye (Ibn e maajah).
            </p>
            <p className="contentSection_title--content">
            Hazrat e Zaid bin Arqam رضى الله تعالى عنه se riwayat h ai keh sahaba kiram ne arz ki ya rasoolallah 
            صلى الله تعالى عليه وسلم ye qurbaa niya kiya hai farmaya keh tumhare baap ibraahim عليه السلام ki 
            sunnat hai lo go ne arz ki ya rasoolallah صلى الله تعالى عليه وسلم hamare liye is me kiya s awab hai
             farmaya har baal ke muqabil neki hai arz ki aur uoon ka kiya hukm hai farmaya keh uoon ke har baal ke
              nadle me neki hai (Ibn e maajah).
            </p>
            <p className="contentSection_title--content">
            Hazrat Barrah رضى الله تعالى عنه se riwayat hai keh nabi e kareem صلى الله تعالى عليه وسلم ne irs
             had farmaya sab se pahle jo kaam aaj ham karenge  woh ye hai keh namaz padhenge aur phir qurbaani
              karenge (Bukhari).
            </p>
            <p className="contentSection_title--content">
            Hazrat e Barrah رضى الله تعالى عنه se riwayat hai k eh Huzur-E-Aqdas صلى الله تعالى عليه وسلم ne 
            farmaya keh aaj ke din jo kaam ham ko pahle karna hai  woh namaz hai aur is ke ba’d qurbaani karna hai
             jis ne aisa kiya  woh hamari sunnat ko pahuncha (Imam ahmad).
            </p>
            <h3 className="contentSection_subtitle"> MASAAIL E FIQHIYYAH</h3>
            <h4 className="contentSection_subheading">QURBAANI KI TA’REEF</h4>
          
            <p className="contentSection_title--content">
            Makhsoos janwar ko makhsoos din me baniyyat e taqarrub zabah karna qurbani hai <span className="referenceTag"><span className="referenceTag">(Bahar e shari’at)</span></span>
            </p>
            <h4 className="contentSection_subheading"> QURBAANI KI Qisme</h4>
            <h4 className="contentSection_subheading">qurbaani ki kayi qisme hain</h4>
            <p className="contentSection_title--content">
            (1) Gani aur faqeer dono par wajib hai is ki soorat ye hai keh qurbani ki mannat maani ye kaha keh 
            allah ke liye mujh par bakri ya gaaye ki qurbaani karna hai ya is bakri ya gaaye ki qurbani karna hai
             <span className="referenceTag"><span className="referenceTag">(Bahar e shari’at)</span></span>
            </p>
            <p className="contentSection_title--content">
            (2) faqeer par wajib ho gani par wajib na ho is ki soorat ye hai keh faqeer ne qurbaani ke liye janwar
             khareeda us par us jaanwar ki qurbaani wajib hai aur agar gani khareedta to is khareedne se qurbaani
              us par wajib na hoti <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <p className="contentSection_title--content">
            (3) gani par wajib ho faqeer par wajib na ho is ki soorat ye hai keh qurbaani ka wujoob na khareedne
             se ho na mannat maanne se balkeh khuda ne jo use zindah rakha hai us ke shukurya me aur Hazrat 
             ibraahim عليه السلام ki sunnat ki ihya me jo Qurbaani wajib hai  woh sirf gani par hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            musafir pe Qurbaani wajib nahi agar musafir ne Qurbaani ki tataww’u (nafl) hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            faqeer ne agar na mannat maani ho na Qurbaani ki niyyat se Jaanwar khareeda ho to uska Qurbaani karna
             bhi tataww’u (nafl) hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            bakri ka maalik tha aur uski Qurbaani ki niyyat kar li ya khareedne ke waqt Qurbaani ki niyyat na thi
             ba’d me niyyat kar li to is niyyat se Qurbaani wajib nahi hogi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h3 className="contentSection_subtitle">QURBAANI KE WAJIB HONE KE SHARAAIT</h3>
            <h4 className="contentSection_subheading">(1) ISLAM</h4>
            <p className="contentSection_title--content">
            yani gair muslim pe Qurbaani wajjb nahi.
            </p>
            <h4 className="contentSection_subheading">(2) IQAAMAT</h4>
            <p className="contentSection_title--content">
            yani muqeem hona musaafir par wajib nahi.
            </p>
            <h4 className="contentSection_subheading">(3) TAWANGARI</h4>
            <p className="contentSection_title--content">
            yani maalik nisaab hona yahan maaldaari se murad wahi hai jis se sadqa e fitr wajib hota hai  woh murad
             nahi jis se zakat wajib hoti hai.
            </p>
            <h4 className="contentSection_subheading">(4) HURRIYYAT</h4>
            <p className="contentSection_title--content">
            yani aazad hona jo aazad na ho us pe Qurbaani wajib nahi keh gulam ke paas maal hi nahi lihaza
             ibadat e maaliya us pe wajib nahi <span className="referenceTag"><span className="referenceTag">(Bahar e shari’at)</span></span>
            </p>

            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            musafir par agarcheh wajib nahi magar nafl ke taur par kare to kar sakta hai sawab paayega
             <span className="referenceTag"><span className="referenceTag">(Bahar e shari’at)</span></span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">sharaait ka poore waqt mem paaya jaana zaroori nahi balkeh
             Qurbaani ke liye jo waqt muqarrar hai uske kisi hissa me sharaait ka paaya jaana wujoob ke liye kaafi 
             hai <span className="referenceTag">(Bahar e shari’at)</span>
              </p>
              <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            ek shakhs ibteda e waqt e Qurbaani me kafir tha phir musalman ho gaya aur abhi Qurbaani ka waqt baaqi
             hai us par Qurbaani wajib hai jab keh dosre sharaait bhi paaye jaayen <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            awwal waqt me musafir tha aur asna e waqt me muqeem ho gaya us par bhi Qurbaani wajib hogi
             <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            faqeer tha aur waqt ke andar maaldaar ho gaya us par bhi Qurbaani wajib hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h3 className="contentSection_subtitle">NISAAB KA BAYAAN</h3>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            jo shakhs (saadhe 52 taula chaandi ) ya saadhe 7 taulah sona ka maalik ho ya haajat ke siwa kisi aisi 
            chiz ka maalik ho jis ki qeemat (saadhe 52 taula chaandi) ho  woh gani hai us par Qurbaani wajib hai 
            <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            haajat e asliyyah se muraad rhne ka makan aur khana daari ke saman jinki haajat ho aur sawari ka janwar
             khadim aur pahanne ke kapde in ke siwa jo chiz hon  woh haajat se zaaid hain <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            maal yahan maujood nahi aur ayyam e Qurbaani guzarne ke ba’d  woh maal use mausool hoga to Qurbaani 
            wajib nahi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            ek makan jaade ke liye aur ek garmi ke liye ye haajat me daakhil hai in ke ilawah us ke paas teedra
             makan ho jo haajat se zaaid hai agar ye 200 dirham (saadhe 52 taula chaandi) ka hai to Qurbaani wajib 
             hai.
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            haajat se zaaid makan hai aur uski qeemat nisaab ko pahunchti ho to Qurbaani wajib hai agarcheh  woh 
            makan kiraya par chalata ho ya khali pada ho (Fatawa razviyyah jild 8 safah 389).
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            makan e sukunat itna bada hai keh uska ek hissa us ke jaade garmi ki sukunat ke liye kaafi ho aur dosra
             hissa haajat se zaaid ho aur uski qeemat tanha ya usi qism ke maal mem milkar nisaab taka pahunche jab
              bhi Qurbaani wajib hai (Fatawa razviyyah jild 8 safah 389).
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            garmi jaade ke bichhone haajat me daakhil hain aur teesra bichhona jo haajat se zaaid hai hai uska
             ietebaar hoga <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            kisi ke paas 2 car hain agar ek se zaroorat poori ho sakti hai aur dosri zaaid hai to aga dosri ki
             qeemat nisaab ko pahunch jaaye Qurbaani wajib hai.
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            2 motor cycle hain ek se zaroorat poori ho sakti hao to dosri wali motor cycle haajat se zaaid hai aur
             dosri motor cycle ki qeemat nisaab ko pahuch jaaye to Qurbaani wajib hai.
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            bartan kuchh isremaal ho rahe hain aur kuchh rakhe huye hain to rakhe huye bartan zaaid hain uska
             bhi ietebaar hoga.
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            tv vedio camra wagairah haajat e asliyyah se nahi lihaza agar unki qeemat nisaab ko pahunch jaaye 
            to Qurbaani wajib hai.
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            fireej , washing masheen, mixer masheen wagairah haajat e asliyyah me hai.
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            ghar me pahanne ke kapde aur kaam kaaj ke waqt pahanne ke kapde aur juma o eidain aur dosre moqo par 
            pahan kar jaane ke kapde ye sab haajat me daakhil hain aur in 3 ke siwa chautha joda agar 200 dirham
             ka hai to qurbani wajib hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            kisi ke paas kuchh zaaid bartan hain magar nisaab ko nahi pahunchte ya zaaid kapde tanha nisaab ko nahi 
            pahunchte ya zaaid gaadi wagairah tanha nisaab ko nahi pahunchti magar ye sab zawaaid mil kar nisaab
             ko pahunch jaaye to Qurbaani wajib hai.
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            kisi ke paas khet hai aur uski qeemat nisaab tak pahunchti ho to us par bhi Qurbaani wajib hai.
             (maakhuz az Fatawa razviyyah jild 8 safah 393/ ahkam shari’at )
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            agar ibteda e waqt m en iska ahal na tha wujoob ke sharaait nahi paaye jaate the aur aakhir waqt me
             ahal ho gaya yani wujoob ke sharaait paaye gaye to us par wajib ho gayi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            agar ibteda e waqt me wajib thi aur abhi ki nahi aur aakhir waqt me sharaait jaate rahe to wajib 
            na rahi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            ek shakhs faqeer tha magar usne Qurbaani kar daali uske ba’d abhi waqt Qurbaani ka baaqi tha keh gani
             (maalik e nisaab) ho gaya to usko phir Qurbaani karni chaahiye keh pahle jo ki thi  woh wajib na thi aur
              ab wajjb hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            agar baawajood maalik nisaab hone ke usne Qurbaani na ki aur waqt khatm hone ke ba’d faqeer ho gaya
             to us par bakri ki qeemat ka sadqa karna wajib hai yani waqt guzarne ke ba’d saaqit nahi hogi 
             <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            ek ghar me kayi afraad maalik e nisaab hain to jitne log maalik e nisaab hain sab par Qurbaani wajib
             hai ghar ke kisi ek fard ki Qurbaani hone se dosre ka wujoob ada na hoga.
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            kayi afraad me maal mushrtarak hai to agar maal shuraka me taqseem karne ke ba’d har fard ke hissa
             me itna maal aata ho keh nisaab ko pahjnch jaaye to sab par Qurbaani wajib hai aur agar har ek ka 
             hissa nisaab se kam ho to kisi par wajib nahi.
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            agar maalik e nisaab bagair Qurbaani kiye huye unhi dino me mar gaya to uski Qurbaani saaqit ho gayi.
             <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            Qurbaani ke waqt me Qurbaani karna hj laazim hai koi dosri chiz uske qaajm maqam nahi ho sakti maslan
             bajaaye Qurbaani usne bakri ya uski qeemat sadqa kar di ye naakaafi hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h3 className="contentSection_subtitle">  JO SAAHIB E ISTETA’AT (استطاعت ) NA HO USKI QURBAANI</h3>
          
            <h4 className="contentSection_subheading">HADEES</h4>
            <p className="contentSection_title--content">
            Hazrat e abdullah bin uamar رضى الله تعالى عنهما se riwayat hai keh rasoolullah 
            صلى الله تعالى عليه وسلم ne farmaya mujhe yaum e azha ka hukm diya gaya us din ko khuda ne is ummat 
            ke liye eid banaya ek shakhs ne arz ki ya rasoolallah صلى الله تعالى عليه وسلم ye bataaiyen agar mere
             paas meenha ke siwa koi Jaanwar na ho to kiya uski Qurbaani kar dun ( meha us janwar ko kahte hain jo
              dosre ne use is liye diya hai keh kuchh dino uske doodh wagairah se faaidah uthaye aur phir maalik ko
               wapas kar de ) Huzur صلى الله تعالى عليه وسلم ne farmaya nahi Haan tum apne baal aur naakhun 
               tarashwaao aur moye zer e naaf mundo is me tumhari Qurbaani khuda ke nazdeek poori ho jaayegi yani
                jisko Qurbaani ki taufeeq na ho to use in chizo ke karne se Qurbaani ka sawab haasil ho jaayega
                 (Abu daaud, nasai).
            </p>
            <h3 className="contentSection_subtitle"> BAAL O NAAKHUN KATWANE KA HUKM</h3>
         
            <h4 className="contentSection_subheading">HADEES</h4>
            <p className="contentSection_title--content">
            ummul mumineen umm e salama رضى الله تعالى عنها se riwayat hai keh Huzur صلى الله تعالى عليه وسلم 
            ne farmaya jis ni Zilhijjah ka chaand dekh liya aur uska iraadah Qurbaani ka hai to jab tak Qurbaani na
             kar le baal o naakhuno se na le yani na tarashwaye (Muslim / tirmizi / nasai).
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            jis ko Qurbaani karne ka iradah ho us ke liye mustahab hai keh zilhijjah ka chaand dekhne ke ba’d 
            naakhun baal wagairah na kaate.
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            agar kisi shakhs ne (31) din se kisi uzr ke sabab, khwah bila uzr naakhun na tarashe hon, khat banwaya
             na ho keh chaand zilhijjah ho gaya to agarcheh Qurbaani ka iradah rakhta ho is mustahab par amal nahi 
             kar sakta keh ab daswen tak rakhega to naakhun o khat banwaye huye ektaaliswan (41) din ho jaayega aur
              40 din se ziyadah na banwana gunaah hai Fe’l e mustahab ke liye gunaah nahi kar sakta.
               (Fatawa razviyyah jild 8 safah 358).
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            jise dosre ya teesre din Qurbaani karni hai us ke liye bihtar hai keh  woh dosre ya teesre din
             Qurbaani ke ba’d naakhun o baal wagairah kaate.
            </p>
            <h4 className="contentSection_subheading">MASLAH:::</h4>
            <p className="contentSection_title--content">
            eid ki namaz ke ba’d aur Qurbaani se pahle naakhun baal wagairah katwa liya to is me bhi harj nahi.
            </p>
           
            <h3 className="contentSection_subtitle">QURBAANI KE JAANWAR KA BAYAAN</h3>
            <h4 className="contentSection_subheading">HADEES:</h4>
            <p className="contentSection_title--content">
            ummul momineen Hazrat e aaishah siddiqa رضى الله تعالى عنها se riwayat hai keh rasoolullah 
            صلى الله تعالى عليه وسلم ne hukm farmaya keh sing wala medha laaya jaaye jo siyahi me chalta ho aur 
            siyahi me baithta ho aur siyahi me nazar karta ho yani uske paaun siyaah hon aur pet siyaah hon aur 
            aankhen siyaah hon  woh Qurbaani ke liye haazir kiya gaya Huzur صلى الله تعالى عليه وسلم ne farmaya
             aaishah chhuri laao phir farmaya use paththar par tez kar lo phir Huzur ne chhuri li aur medhe ko
              litaaya aur use zabah kiya phir farmaya بِسْمِ اللّٰهِ اَللّٰهُمَّ تَقَبَّلْ مِنْ مُحَمَّدٍ وَ اٰلِ مُحَمَّدٍ وَ مِنْ اُمَّةِ مُحَمَّدٍ Ilahi
               to isko muhammad صلى الله تعالى عليه وسلم ki taraf se aur unki aal ki aur ummat ki taraf se qubool
                farma (Muslim ).
            </p>
            <h4 className="contentSection_subheading">HADEES:</h4>
            <p className="contentSection_title--content">
            Hazrat e abdullah bin mas’ood رضى الله تعالى عنه se riwayat hai keh Huzur صلى الله تعالى عليه وسلم 
            ne farmaya Qurbaani me gaaye 7 ki taraf se aur oont 7 ki taraf se hai (Tibrani).
            </p>
            <h4 className="contentSection_subheading">HADEES:</h4>
            <p className="contentSection_title--content">
            Hazrat majaashe’ bin mas’ood رضى الله تعالى عنه se riwayat hai keh hazur صلى الله تعالى عليه وسلم 
            ne farmaya bhed ka jaza’a ( 6 mahine ka bachcha ) saal bhar wali bakri ke qaaim maqam hai.
             (Abu daaud o nasai).
            </p>
            <h4 className="contentSection_subheading">HADEES:</h4>
            <p className="contentSection_title--content">
            Hazrat e ali رضى الله تعالى عنه se riwayat hai keh Huzur صلى الله تعالى عليه وسلم ne farmaya 4 qism
             ke Jaanwar Qurbaani ke liye durust nahi, kaana jiska kaanapan zaahir hai, aur beemaar jiski beemari 
             zaahir ho, langda jiska lang zaahir hai, aur aisa laagar jiski haddiyion me magz na ho (Imam ahmad).
            </p>
            <h4 className="contentSection_subheading">HADEES:</h4>
            <p className="contentSection_title--content">
            Hazrat e ali رضى الله تعالى عنه se riwayat hai keh rasoolullah صلى الله تعالى عليه وسلم ne kaan kate
             huye sing toote huye ki Qurbaani se mana farmaya (Ibn e maajah / imam ahmad).
            </p>
            <h4 className="contentSection_subheading">HADEES:</h4>
            <p className="contentSection_title--content">
            Hazrat e ali رضى الله تعالى عنه se riwayat hai keh rasool e akram صلى الله تعالى عليه وسلم ne 
            farmaya keh ham Jaanwaro ke kaan aur aankhen gaur se dekh len aur uski Qurbaani na kren jiske kaan
             ka agla hissa kata ho aur na uski jis ke kaan ka pichhla hissa kata ho na uski jiska kaan phata ho 
             ya kaan me sooraakh ho ( tirmizi / abu daaud / nasai).
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <h4 className="contentSection_subheading">Qurbaani ke Jaanwar 3 qism ke hain :</h4>
            <p className="contentSection_title--content">
            (1) oont.
            </p>
            <p className="contentSection_title--content">
            (2) gaaye.
            </p>
            <p className="contentSection_title--content">
            (3) bakri.
            </p>
            <p className="contentSection_title--content">
            Har qism me uski jitni nau’aen hain sab daakhil hain narr o maadah khassi aur gair e khassi sab ka ek
             hukm hai yani sab ki Qurbaani ho sakti hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            bhains gaaye me shumaar hai uski bhi Qurbaani ho sakti hai – bhed aur dumbah bakri me daakhil hain unki 
            bhi Qurbaani ho sakti hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            wahshi (jangli) Jaanwar jaise neel gaaye aur hiran inki Qurbaani nahi ho sakti <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            murgi ki Qurbaani jaayez nahi (Fatawa razviyyah jild 8 safah 530).
            </p>
            <h3 className="contentSection_subtitle">QURBAANI KE JAANWAR KI UMAR KA BAYAAN</h3>
            <h4 className="contentSection_subheading">Qurbaani ke janwar ki umar ye honi chaiye</h4>
            <p className="contentSection_title--content">
            Oont 5 saal ka, gaaye 2 saal ki, bakri 1 saal ki , is umar se kam ho to Qurbaani jaayez nahi ziyadah
             ho to jaayez balkeh afzal hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            dumbah ya bhed ka 6 maah ka bachcha agar itna bada ho keh door se dekhne me saal bhar ka maloom hota 
            ho to uski Qurbaani jaayez hai. <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            bakri ki qeemat aur gosht agar gaaye ke saatwen hissa ke barabar ho to bakri afzal hai aur gaaye ke
             saatwen hissa me bakri se ziyadah gost ho to gaaye afzal hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            medha bhed se aur dumbah dumbi se afzal hai jab keh dono ki qeemat ek ho aur dono me gosht barabar ho.
             <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            bakri bakre se afzal hai magar khassi bak ra bakri se afzal hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            oontni oont se aur gaaye bail se afzal hai jab keh gosht aur qeemat me barabar hon. <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h3 className="contentSection_subtitle">QURBAANI KE JAANWAR me AIB KA BAYAAN</h3>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ke Jaanwar ko aib se khaali hona chaahiye aur thoda sa aib ho to Qurbaani ho jaayegi magar
             makrooh hogi aur zyadah aib ho to hogi hi nahi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            jis ke paidaashi sing na ho to uski Qurbaani jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            agar sing the magar toot gaya aur meg (gooda) tak toota hai to jaayez nahi is se kam toota hai to jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            jis Jaanwar me junoon (paagalpan) hai aur is hadd ka hai keh  woh Jaanwar charta bhi nahi hai to uski 
            Qurbaani naajaayaz hai aur is hadd ka nahi hai to jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            khassi yani jiske khusiye nikaal liye gaye hon ya majboob yani jis ke khusiye aur uzu e tanaasul sab 
            kaat liye gaye hon unki Qurbaani jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            itna boodha keh bachcha ke qqabil na raha ya daaga hua Jaanwar ya jiske doodh na utarta ho in sab ki
             Qurbaani jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            kharishi Jaanwar ki Qurbaani jaayez hai jabkeh farbah (mota) ho <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            aur itna laagar (dubla) ho keh haddi me magz na raha to Qurbaani jaayez nahi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            bhenge Jaanwar ki Qurbaani jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            andhe Jaanwar ki Qurbaani jaayez nahi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            kaana jiska kaanapan zaahir ho uski Qurbaani naajaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            langda jo Qurbaangaah tak apne paaun se na jaa sake aur itna beemaar jiski baamaari zaahir ho aur jiske
             kaan ya dum ya chakki kate hon yani  woh uzu tihaai se ziyadah kate hon un sab ki Qurbaani naajaayez hai
              <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            agar kaan ya dum ya chakki tihaai ya is se kam kati ho to jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Jis Jaanwar ke paidaaishi kaan na hon ya 1 kaan na ho uski Qurbaani naajaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            jis ke kaan chhote hon uski Qurbaani jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            jis Jaanwar ki tahaai se ziyaadah nazar jaati rahi uski bhi Qurbaani naajaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            jis ke daant na ho uski Qurbaani naajaayez hai <span className="referenceTag">(Bahar e shari’at)</span> yani jis ke daant jhad gaye hon.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ke Jaanwar ka daanta hona zaroori nahi agar umar poori ho to agarcheh daanta na ho uski
             Qurbaani jaayez hai.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            jis ke than kate hon ya khushk hon uski Qurbaani naajaayez hai bakri me 1 ka khushk hona naajaayez hone
             ke liye kaafi hai aur gaaye , bhains me 2 khushk hon to naajaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            jis ki naak kati ho ya ilaj ke zarye uska doodh khush kar diya ho aur khunsa Jaanwar yani jis
             me narr o maadah dono ki alamaten hon aur jallalah jo sirf galeez khata ho un sab ki Qurbaani
              naajaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            bhed ya dumbah ki uoon (baal) kaat li gayi ho uski Qurbaani jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            jis Jaanwar ka 1 paaun kaat liya gaya ho uski Qurbaani naajaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Jaanwar ko jis waqt khareeda tha us waqt us me aisa aib na tha jiski wajah se Qurbaani naajaayez hoti 
            hai ba’d me  woh aib paida ho gaya to agar  woh shakhs maalik e nisaab hai to dosre Jaanwar ki Qurbaani
             kare aur agar maalik e nisaab nahi hai to usi ki Qurbaani kar le ye us waqt hai keh us faqeer ne
              pahle se apne zimmah Qurbaani wajib na ki ho aur agar us ne mannat maani hai keh bakri ki Qurbaani 
              karunga aur mannat poori karne ke liye bakri khareedi us waqt bakri me aib na tha phir paida ho gaya 
              is soorat me faqeer ke liy e bhi yahi hukm hai keh dosre Jaanwar ki Qurbaani kare <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            faqeer ne jis waqt Jaanwar khareeda tha us waqt us me aisa aib tha jis se Qurbaani naajaayez hoti hai 
            aur  woh aib Qurbaani ke waqt tak baaqi raha to uski Qurbaani kar sakta hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
               <p className="contentSection_title--content">
               gani aibdaar khareede aur aibdaar hi ki Qurbaani kare to naajaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani karte waqt Jaanwar uchhla kooda jiski wajah se aib paida ho gaya ye aib muzir nahi yani 
            Qurbaani ho jaayegi aur agar uchhalne koodne se aib paida ho gaya aur o h chhoot kar bhaag gaya aur
             fauran pakad laaya gaya aur zabah kar diya gaya jab bhi Qurbaani ho jaayegi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            agar aibi Jaanwar ko khareeda tha aur ba’d me uska aib jaata raha to gani aur faqeer dono ke liye uski
             Qurbaani jaayez hai maslan aisa laagar (dubla) Jaanwar khareeda jiski Qurbaani naajaayez hai aur uske
              yahan  woh farbah ho gaya to gani bhi uski Qurbaani kar sakta hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            bakara jo khassi nahi hota  woh aksar peshaab peene ka aadi hota hai us me aisi sakht badboo paida ho
             jaati hai keh jis raasta se guzarta hai  woh raasta kuchh der ke liye badboodaar ho jaata hai uska bhi
              wahi hukm hai jo jallalah ka hai keh agar uske gosht se badboo daf’a ho gayi to kha sakte hain warna
               makrooh o mamnoo’ hai <span className="referenceTag">(Bahar e shari’at)</span> chunkeh jallalah ki Qurbaani jaayez nahi hai lihaza jo log
                aise bakre ki Qurbaani karte hain jo peshaab peeta ho un par zaroori hai keh aise bakre ko itne din 
                is tarah baandh kar rakhen keh peshaab na pi sake aur uske jism aur gosht se badboo rafa’ jo jaaye.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            jaanwaro ko aapas me ladaana naajaayez o haraam hai HADEES shareef me hai rasoolullah 
            صلى الله تعالى عليه وسلم ne chaupaayon ko ladaane se mana farmya <span className="referenceTag">(Bahar e shari’at)</span> ba’z log Qurbaani
             ke ayyaam se pahle hi bakre khreed lete hain aur tafreehan unhen aapas me ladaate hain aisa karna 
             jaayez nahi keh is me un bezabaan Jaanwaro ko eezaa dena hai ,.. aise tamaasho me shirkat bhi jaayez
              nahi.
            </p>
            <h3 className="contentSection_subtitle">QURBAANI KA HUKM</h3>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ka hukm ye hai keh us ke zimmah jo Qurbaani wajib hai kar lene se bariuzzimmah ho gaya.
             <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            achhi niyyat se ki hai riya (dikhawa) wagairah ki mudakhalat nahi to allah ke fazl se ummeed hai
             keh aakhirat me uska sawab mile.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            ek se ziyadah Qurbaani ki sab Qurbaaniyaan jaayez hain ek wajib baaqi nafl <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            agar ek poori gaaye Qurbaani ki to poori se wajib hi ada hoga ye nahi keh saatwa hissa hi wajib ho
             baaqi nafl <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h3 className="contentSection_subtitle">QURBAANI KI MANNAT KA BAYAN</h3>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ki mannat sahih hai agar shart paayi gayi to Qurbaani karna wajib hai maslan kisi ne kaha mera
             fulaan kaam ho jaaye to main Qurbaani karunga aur  woh kaam ho gaya to Qurbaani wajib hai.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ki mannat maani aur ye mu’ayyan nahi kiya keh gaaye ki Qurbaani karega ya bakri ki to mannat sahih hai
             bakri ki Qurbaani kar dena kaafi hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            agar bakri ki Qurbaani ki mannat maani to oont ya gaaye Qurbaani kar dene se bhi mannat poori ho jaayegi .
            <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            mannat ki Qurbaani me se kuchh na khaye balkeh sara gosht wagairah sadqa kar de aur kuchh kha liya to
             jitna khaya uski qeemat sadqa kar de <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            maalik e nisaab ne Qurbaani ki mannat maani to uske zimmah 2 Qurbaaniyaa wajib ho gayin ek  woh jo gani 
            par wajib hoti hai aur ek mannat ki wajah se <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            2 yaa 2 se ziyaadah Qurbaaniyo ki mannat maani to jitni Qurbaaniyo ki mannat hai sab wajib hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h3 className="contentSection_subtitle">QURBAANI KA WAQT</h3>
            
            <h4 className="contentSection_subheading">HADEES:</h4>
            <p className="contentSection_title--content">
            Hazrat e barraa رضى الله تعالى عنه se riwayat hai keh nabi kareem صلى الله تعالى عليه وسلم ne
             farmaya sab se pahle jo kaam aaj ham karenge  woh ye hai keh namaz padhen phir is ke ba’d Qurbaani 
             karenge, jis ne aisa kiya us ne hamari sunnat (tareeqa) ko paa liya aur jis ne pahle zabah kiya oh
              gosht hai jo us ne pahle se apne ghar walon ke liye tayyaar kar liya Qurbaani se use kuchh ta’alluq
               nahi abu burdah رضى الله تعالى عنه kahde huye aur ye pahle hi zabah kar chuke the 
               (is khayal se keh pados ke log gareeb the unhon ne chaha keh unko gosht mil jaaye ) 
               aur arz ki ya rasoolallah صلى الله تعالى عليه وسلم mere paas bakri ka 6 maah ka ek bachcha hai
                Faramya tum use zabah kar lo aur tumhare siwa kisi ke liye 6 maaha bachcha kifayat nahi karega
                 (Bukhari).
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ka waqt daswen zihijjah ke tulu e subh e saadiq se baarahwen ke gurub e aaftaab tak hai,
              yani 3 din 2 raaten <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            daswen ke ba’d ki dono raaten ayyaam e nahar mem daakhil hain un me Qurbaani ho sakti hai magar raat
             mem Qurbaani karna makrooh hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            pahla din yani daswen tareekh sab me afzal hai phir giyarahwen aur pichhla din yani baarahwen sab se
             kam darjah hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            ayyaam e nahar me Qurbaani karna itni qeemat ke sadqa karne se afzal hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            wujoob ki soorat me bagair Qurbaani kiye uhda baraa nahi ho sakta <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            shahar me Qurbaani ki jaaye to shart ye hai keh namaz ho chuke lihaza namaz e eid se pahle shahar me 
            Qurbaani nahi ho sakti <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            dehaat me chunkeh namaz e eid nahi hai yahan tulu e fajr ke ba’d se hi Qurbaani ho sakti hai 
            <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            dehaat me bihtar ye hai keh ba’d e tulu e aaftaab Qurbaani ki jaaye <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            shahar me bihtar ye hai keh eid ka khutbah ho chukne ke ba’d Qurbaani ki jaaye <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            namaz ho chuki hai aur abhi khutbah nahi hua hai is soorat me Qurbaani ho jaayegi magar aisa karna
             makrooh hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            ye jo shahar aur dehaat ka farq batataya gaya hai ye maqam e Qurbaani ke lihaz se hai Qurbaani karne
             wale ke ietebaar se nahi yani dehaat me Qurbaani ho to  woh waqt hai agarcheh Qurbaani karne wala shahar
              me hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            shahar me ho to namaz ke ba’d ho agarcheh jis ki taraf se Qurbaani hai  woh dehaat mem ho <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            shahar me aadmi agar ye chaahta hai keh subah hi namaz se pahle Qurbaani ho jaaye to Jaanwar dehaat me
             bhej de <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            agar shahar me muta’addad jagah eid ki aamaz hoti ho to pahli jagah namaz ho chukne ke ba’d Qurbaani
             jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            imam abhi namaz hi me hai aur kisi ne Jaanwar zabah kar liya agarcheh imam qa’da me ho aur baqadr e 
            tashahhud baith chuka ho magar abhi salam na phera ho to Qurbaani nahi hui <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            agar imam ne ek taraf salam pher liya hai dosri taraf baaqi tha keh us ne zabah kar diya Qurbaani
             ho gayi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            ayyaam e nahar guzar gaye aur jis par Qurbaani wajib thi us ne nahi ki hai to Qurbaani faut ho gayi ab
             nahi ho sakti agar usne Qurbaani ka Jaanwar mu’ayyan kar rakha hai maslan mu’ayyan Jaanwar ke Qurbaani
              ki mannat maan li hai  woh shakhs gani ho ya faqeer bahar soorat usi mu’ayyan Jaanwar ko zindah sadqa 
              kare aur agar zabah kar daala to saara gosht sasqa kare us me se kuchh n MASLAH::: faqeer ne Qurbaani
               ki niyyat se Jaanwar khareeda aur Qurbaani ke din nikal gaye chunkeh us par bhi usi mu’ayyan Jaanwar
                ki Qurbaani wajib hai lihaza us Jaanwar ko zindah sadqa kar de <span className="referenceTag">(Bahar e shari’at)</span>
                 MASLAH::: ye zaroori nahi keh daswen hi ko Qurbaani kar daale Us ke liye gunjaaush hai keh poore
                  waqt me jab chahe kare <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h3 className="contentSection_subtitle">QURBAANI KA TAREEQA</h3>
          
            <h4 className="contentSection_subheading">HADEES::</h4>
            <p className="contentSection_title--content">
            Hazrat e jaabir رضى الله تعالى عنه se riwayat hai keh nabi kareen صلى الله تعالى عليه وسلم ne zabah ke din 2 
            medhe singh wale chitkabre khassi kiye huye zabah kiye jab unka munh qibla ko kiya ye padhen
             إِنِّی وَجَّہْتُ وَجْہِیَ لِلَّذِی فَطَرَ السَّمٰوٰتِ وَالْأَرْضَ حَنِیفًاوَّمَا أَنَا مِنَ الْمُشْرِكِین إِنَّ صَلَاتِی وَنُسُكِی 
             وَمَحْیَایَ وَمَمَاتِی لِلَّہِ رَبِّ الْعٰلَمِینَ لَا شَرِيْكَ لَه وَبِذَالِكَ اُمِرْتُ وَ اَنَا مِنَ الْمُسْلِمِيْن اَللّٰهُمَّ لَكَ وَ مِنْكَ بِسْمِ اللّٰهِ اللّٰهُ اَكْبَر 
             Is ko padh kar zabah farmaya ek riwayat me hai keh Huzur صلى الله تعالى عليه وسلم ne ye farmaya keh ilahi ye
              meri taraf se hai aur meri ummat me uski taraf se hai jis ne Qurbaani nahi ki (Abu daaud / ibn e maajah)
            </p>
            <h4 className="contentSection_subheading">HADEES::</h4>
            <p className="contentSection_title--content">
            Hazrat anas رضى الله تعالى عنه se riwayat hai keh nabi kareem صلى الله تعالى عليه وسلم Ne 2 medhe
             chitkabre sing walo ki Qurbaani ki unhen apne dast e mubarak se zabah kiya aur بِسْمِ اللّٰهِ وَاللّٰهُ اَكْبَر 
             Kaha, kahte hain main ne Huzur ko dekha keh apna paaun un ke pahluon par rakha aur بِسْمِ 
             اللّٰهِ وَاللّٰهُ اَكْبَر Kaha (Bukhari / muslim)
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            ye shubah keh ek medha un sab ki taraf se kiyon kar ho sakta hai ya jo log abhi paida hi na huye unki
             Qurbaani kiyon kar hui iska jawab ye hai keh ye Huzur-E-Aqdas صلى الله تعالى عليه وسلم ke khasaais
              se hai jis tarah Huzur ne 6 mahine ki bakri ke bachchah ki Qurbaani abu burdah رضى الله تعالى عنه 
              ke liye jaayez farma di auron ke liye uski mumana’at kar di isi tarah is me khud Huzur ki khususiyyat
               hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ka tareeqa ye hai keh Jaanwar un sharaait ke muwafiq hon jo mazkoor hui yani jo us ki umr 
            baatai gayai us se kam na ho aur un uyoob se paak ho jinki wajah se Qurbaani naajaayez hoti hai aur
             bihtar ye keh umdah o farbah ho Qurbaani se pahle use chaarah paani de den yani bhooka piyasa zabah 
             na karen aur ek ke saamne dosre ko zabah na karen aur pahle se chhuri tez kar len aisa na ho keh
              Jaanwar girane ke ba’d uske saamne chhuri tez ki jaaye Jaanwar ko baayen pahlu par is tarah litaayen
               keh qiblah ko uska munh ho aur apna daahina paaun uske pahlu par rakh kar tez chhuri se jald zabah 
               kar diya jaaye aur zabah se pahle ye dua padhi jaaye إِنِّی وَجَّہْتُ وَجْہِیَ لِلَّذِی فَطَرَ السَّمٰوٰتِ وَالْأَرْضَ حَنِیفًاوَّمَا أَنَا مِنَ الْمُشْرِكِین إِنَّ صَلَاتِی وَنُسُكِی وَمَحْیَایَ وَمَمَاتِی لِلَّہِ رَبِّ الْعٰلَمِینَ لَا شَرِيْكَ لَه وَبِذَالِكَ اُمِرْتُ وَ اَنَا مِنَ 
               الْمُسْلِمِيْن اَللّٰهُمَّ لَكَ وَ مِنْكَ بِسْمِ اللّٰهِ اللّٰهُ اَكْبَر Ise padh kar zabah kar de Qurbaani apni taraf se ho 
               to zabah ke ba’d ye dua padhe..

اَللّٰهُمَّ تَقَبَّلْ مِنِّىْ كَمَا تَقَبَّلْتَ مِنْ خَلِيْلِكَ اِبْرَاهِيْمَ عَلَيْهِ السَّلَام وَ حَبِيْبِكَ مُحَمَّدٍ صَلَّى اللّٰه تَعَالىٰ عَلَيْهِ وَسَلَّمْ Is tarah zabah kare keh chaaro ragen kat jaayen ya kam se kam 3 ragen kat jaayen is se ziyadah na kaaten keh chhuri gardan ke muhra tak pahunch jaaye keh ye be wajah ki takleef hai phir jab tak Jaanwar thanda na ho jaaye yani jab tak uski rooh bilkul na nkkal jaaye uske paaun wagairah na kaate na khaal utaare aur agar dosre ki taraf se zabah karna hai to مِنِّىْ ki jagah مِن Ke ba’d uska name le aur agar  woh mushtarak Jaanwar hai jaise gaaye, oont to wazan se gosht taqseem kiya jaaye mahaz takhmeena (andazah) se taqseem na karen <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani karne wala baqra’eed ke din sab se pahle Qurbaani ka gosht khaye is pahle koi dosri chiz
             na khaye ye mustahab hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">FAAIDAH:</h4>
            <p className="contentSection_title--content">
            ahadees se saabit hai keh saiyyid e aalam صلى الله تعالى عليه وسلم ne is ummat e marhooma ki taraf se 
            Qurbaani ki ye Huzur ke be shumaar altaaf me se ek khaas karam hai keh is moqa par bhi ummat ka khiyaal
             farmaya aur jo log Qurbaani na kar sake unki taraf se khud hi Qurbaani ada farmaai jab Huzur ne ummat
              ki taraf se khud Qurbaani ki to jo musalman saahib e isteta’at ho agar Huzur-E-Aqdas صلى الله 
              تعالى عليه وسلم ke name ki ek Qurbaani kare to zahe naseeb aur bihtar sing wala medha hai jis ki 
              siyaahi me safaidi ki bhi aamezish ho jaise medhe k e khud Huzur akram صلى الله تعالى عليه وسلم 
              ne Qurbaani farmaai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h3 className="contentSection_subtitle">DOOSRE KI TARAF SE QURBAANI KA BAYAAN</h3>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani me niyabat ho sakti hai yani khud karna zaroorai nahi balkeh dosre ko iajzat dede, 
            usne kar di ye ho sakta hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            baalig ladko ya biwi ki taraf se Qurbaani karna chahta hai to unse ijazat haasil kare bagair agr kardi
             to unki taraf se wajib ada na hua <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            naabaalig ki taraf se agarche wajib nahi magar kar dena behtar hai <span className="referenceTag">(Bahar e shari’at)</span> Is soorat me 
            naabaalig bachcho se ijazat ki zaroorat nahi.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            apni taraf se aur apne bachcho ki taraf se gaaye ki Qurbaani ki agar wo naabaalig hain to sab
             Qurbaaniyan jaayez hain aur baalig hain aur sab ladkon ne kah diya (ijazat de di) hai to sab
              ki taraf se sahih hai aur agar unhone kaha nahi ya ba’z(kuch) ne nahi kaha to kisi ki Qurbaani 
              nahi hui <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            kisi shakhs ne wasiyyat ki uski taraf se Qurbaani kar di jaaye aur ye nahi bataya ki gaaye ya bakri 
            kis Jaanwar ki Qurbaani ki jaaye aur na qeemat bayan ki keh istne ka Jaanwar khareed kar Qurbaani ki
             jaaye ye wasiyyat jaayez hai aur bakri Qurbaan kar dene se wasiyyat poori ho gayi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h3 className="contentSection_subtitle">QURBAANI me SHIRKAT KA BAYAAN</h3>
            <h4 className="contentSection_subheading">HADEES:</h4>
            <p className="contentSection_title--content">
            Hazrat abdullah bin mas’ood رضى الله تعالى عنه se riwayat hai keh Huzur صلى الله تعالى عليه وسلم 
            ne farmaya Qurbaani me gaaye 7 ki taraf se aur uoont 7 ki taraf se hai (Tibrani)
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            jab Qurbaani ke sharaait e mazkoorah paaye jaayen to bakri ka zabah karna ya uoont ya gaaye ka saatwa 
            hissa wajib hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            saatwen hissa se kam nahi ho sakta balkeh uoont ya gaaye ke shuraka me agar kisi shareek ka saatwen
             hissa se kam hai to kisi ki Qurbaani nahi hui yani jiska saatwa hissa ya us se ziyadah ho uski bhi 
             Qurbaani nahi hui <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            gaaye ya uoont me saatwen hissa se ziyaadah ki Qurbaani ho sakti hai maslan gaaye ko 6 ya 5 ya 4
             shakhso ki taraf se Qurbaani karen ho sakta hai aur ye zaroori nahi keh sab shuraka ke hisse barabar
              hon balkeh kam o besh bhi ho sakte hain, haan ye zaroor hai keh jiska hissa kam hai  woh saatwen hissa
               se kam na ho <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            7 shakhso ne 5 gaayo ki Qurbaani ki ye jaayez hai keh har gaaye me har shakhs ka saatwa hissa hua <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            gaaye ke shuraka me se ek kaafir hai ya un me se ek shakhs ka maqsood Qurbaani nahi balkeh gosht 
            haasil karna hai to kisi ki Qurbaani nahi hui <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ke sab shuraka ki niyyat taqarrub ho iska ye matlab hai keh kisi ka irada gosht na ho aur
             ye zaroori nahi keh  woh taqarrub ek hi qism ka ho maslan sab Qurbaani hi karna chaahte hain balkeh
              agar mukhtalif qism ke taqarrub hon  woh taqarrub sab par wajib ho ya kisi par wajib ho aur kisi par
               wajib na ho har soorat me Qurbaani jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani aur aqeeqah ki bhi shirkat ho sakti hai keh aqeeqah bhi taqarrub ki ek soorat hai
             <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            shuraka me koi devbandi wahabi aur gair muqallid wagairah hai to kisi ki Qurbaani na hui.
            </p>
            <h3 className="contentSection_subtitle">ZABAH KA BAYAAN</h3>
            <p className="contentSection_title--content">
            Allah azza o jalla farmata hai حُرِّمَتْ عَلَیْكُمُ الْمَیْتَۃُ وَالدَّمُ وَلَحْمُ الْخِنزِیرِ 
            وَمَا أُہِلَّ لِغَیْرِ اللَّہِ بِہِ وَالْمُنْخَنِقَۃُ وَالْمَوْقُوذَۃُ وَالْمُتَرَدِّیَۃُ وَالنَّطِیحَۃُ وَمَا أَكَلَ 
            السَّبُعُ إِلَّا مَا ذَكَّیْتُمْ وَمَا ذُبِحَ عَلَى النُّصُبِ وَأَن تَسْتَقْسِمُوا بِالْأَزْلَامِ ۚ ذَٰلِكُمْ فِسْقٌ ۗ Tum par haraam hai mudaar aur
             khoon aur suwwar ka gosht aur jis ke zabah me gair e khuda ka name pukara gaya aur jo gala ghontne se 
             mar jaaye aur dab kar mara hua yani bedhaar ki chiz se maara hua aur jo gir kar mara ho aur jisko kisi
              Jaanwar ne singj maara ho aur jis ko darindah ne kuchh khaa liya ho magar  woh jinhen tum zabah kar lo 
              aur jo kisi thaan par zabah kiya gaya ho aur teero se taqdeer ko maloom karna ye gunaah ka kaam hai
              <span className='referenceTag'>
              Surah 5 سُورَۃُ الْمَآىِٕدَة | Ayah 3
                </span>
            </p>
            <p className="contentSection_title--content">
            وَلَا تَأْكُلُوا مِمَّا لَمْ یُذْكَرِ اسْمُ اللَّہِ عَلَیْہِ وَإِنَّہُ لَفِسْقٌ ۗ Aur use na khaao jis pe allah ka name nahi liya gaya
             aur  woh beshak hukm udooli hai
            </p>
            <span className='referenceTag'>
            Surah 6 سُورَۃُ الْاَنْعَام | Ayah 121
                </span>
            <h4 className="contentSection_subheading">HADEES:</h4>
            <p className="contentSection_title--content">
            Hazrat e abdullah bin abbas o abu hurairah رضى الله تعالى عنهم se riwayat hai keh rasoolullah 
            صلى الله تعالى عليه وسلم ne شريطة الشيطن se mumana’at farmaayi ye  woh zabeeha hai jiski khaal kaati
             jaaye aur ragen na kaati jaayen aur chhod diya jaaye yahan tak keh mar jaaye (Abu daaud)
            </p>
            <h4 className="contentSection_subheading">HADEES::</h4>
            <p className="contentSection_title--content">
            ummul mumineen Hazrat e aaishah siddiqa رضى الله تعالى عنها se riwayat hai keh logo ne arz ki ya 
            rasoolallah صلى الله تعالى عليه وسلم yahan kuchh log abhi naye musalman huye hain  woh hamare paas 
            gosht laaye hain hame maloom nahi keh allah ka name unhon ne zikr kiya hai ya nahi , farmaya keh 
            bismillah kaho aur khaao yani muslim ke zabeeha me is qism ke ihtemalaat na kiye jaayen (Bukhari)
            </p>
            <h4 className="contentSection_subheading">HADEES::</h4>
            <p className="contentSection_title--content">
            shaddad bin aus رضى الله تعالى عنه se riwayat hai keh rasoolullah صلى الله تعالى عليه وسلم ne
             farmaya keh Allah tabarak o ta’ala ne har chiz me khoobi karna likh diya hai, , lihaza qatl karo to
              us me bhi khoobi ka lihaz rakho (yani be sabab usko eeza mat pahunchaao) Aur zabah karo to zabah me
               khoobi karo aur apni chhuri ko tez kar lo aur zabeeha ko takleef na pahunchaao (Muslim)
            </p>
            <h3 className="contentSection_subtitle">MASAAIL E FIQHIYYAH</h3>
            
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            gale me chand ragen hain inko kaatne ko “zabah” kahte hain aur us Jaanwar ko jiski  woh ragen kaati gayi
             ” zabeeha” aur “zibah” kahte hain yahan zaal ko zer hai aur pahli jagah zabar hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            ba’z Jaanwar zabah kiye jaate hain ba’z nahi jo shar’an zabah nahi kiye jaa sakte hain un me ye do
             machhli aur tiddi bagair zabah kiye halaal hain <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            zabah ki jagah halaq aur lubbah ke maabain (darmiyan) hai lubbah seene ke baalaai hissa ko kahte hain
             <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            awam me ye mashhoor hai keh uoont ko 3 jagah zabah kiya jaata hai galat hai aur yun karna makrooh hai
             keh bila faaidah eeza dena hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            jo ragen zabah me kaati jaati hain  woh 4 hain (1) hulqoom ye  woh hai jis me saans aati jati hai (2) muri 
            is se khana paani utarta hai (3/4) in dono ke agal bagal aur 2 ragen hain jin me khoon ki rawani hai
             unko “wadjain” kahte hain <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            poora hulqoom zabah ki jagah hai yani uske a’ala ausat asfal jis jagah me zabah kiya jaaye halaal hoga <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            aaj kal chunkeh chamde ka narkh (qeemat) ziyadah hai aur ye wazan ya naap se farokht hota hai is liye
             qassab iski koshish karte hain keh kisi tarah chamde ki miqdar badh jaaye aur is ke liye ye tarkeeb 
             karte hain keh bahut uoopar se zabah karte hain aur is soorat me aisa bhi ho sakta hai keh zibah 
             fauqul uqdah ho jaaye aur is me ulama ko ikhtelaf hai keh Jaanwar halaal hoga keh nahi is baab me
              qaul e faisal ye hai keh zibah fauqul uqdah me agar 3 ragen kat jaayen to Jaanwar halaal hai wrna
               nahi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            ulama ka ikhtelaf aur ragon ke katne me ihtemaal dekhte huye ihteyaat zaroori hai keh ye mu’aamala
             hillat o hurmat ka hai aur aise maqam par ihteyaat laazim hoti hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            zibah ki 4 ragon me se 3 ka kat jaana kaafi hai yani is soorat me bhi Jaanwar halaal ho jaayega <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            agar chaaro me se har ek ka aksar hissa kat jaayega jab bhi halaal ho jaayega <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            aadhi aadhi har rag kat gayi aur aadhi baaqi baaqi hai to halaal nahi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h3 className="contentSection_subtitle">ZAROORI INTEBAAH</h3>
            <p className="contentSection_title--content">
            Qurbaani me aksar aisa hota hai keh zabah karne wala Jaanwar ke gale pe chhuri phiraata hai aur sirf
             chamdi kat ti hai keh qassaab chhuri le kar khud zabah karne lagta hai to is soorat me bhi 3 ragon ka 
             bilkul katna ya chaaro rago ka aksar hissa kat jaana zaroori hai, agar 3 ragen mukammal na kati ya
              chaaro ragon ka aksar hissa na kata aur Jaanwar tadap tadap kar mar gaya to  woh Jaanwar bhi haraam
               hai aur Qurbaani bhi nahi hui, ,is masla se bahut se log gaafil hain.
            </p>
            <h4 className="contentSection_subheading">TAMBEEH:</h4>
            <p className="contentSection_title--content">
            ba’z murgi wagirah ki dukan me dekha gaya keh qassaab waqt e zabah murgi ke gale pe chhuri phiraate 
            hain sirf chamdi hi kati hoti hai sab ragen nahi kati hoti keh kisi darum wagairah me daal dete hain
             taakeh rooh nikal jaaye, to agar 3 rag mukammal katne se pahle ya chaaro rago ka aksar hissa katne
              se pahle aisa kiya aur murgi tadap tadap kar mar gayi to  woh murgi Haraam hai.
            </p>
            <h4 className="contentSection_subheading">TAMBEEH::</h4>
            <p className="contentSection_title--content">
            ba’z logo me ye mashhoor hai keh bakra dedh salla yani gale par dedh martaba chhuri phirane me hi
             zabah ho jaana chahiye is ki bhi koi asl nahi yunhi gaaye bail wagiarah ke gale pe dhaai salla yani
              dhaai martaba chhuri phirane me hi zabah ho jaana chahiye iski bhi koi asl nahi balkeh agar dedh
               martaba bakri ke gale pe aur dhaai martaba bail ke gale pe chhuri phiraaya aur 3 ragen mukammal
                nahi kati ya chaaro ragon ka aksar hissa nahi kata aur Jaanwar tadap tadap ke mar gaya  woh Jaanwar
                 bhi haraam hai aur Qurbaani bhi nahi hui balkeh chaaro ragon ke kaatne ka hukm hai to ye chaaro 
                 ragen jitni martaba chhuri phirane se kate kaatna zaroori hai agar 1 hi martaba phirane me chaaro
                  ragen kat jaayen halaal hai ya 10 martaba phirane me kate har haal me charo ragon ka katna
                   zaroori hai.
            </p>
            <h3 className="contentSection_subtitle">ZABAH SE JAANWAR HALAAL HONE KE LIYE CHAND SHARTEN HAIN</h3>
            <p className="contentSection_title--content">
            (1) zabah karne wala aaqil ho majnoon (paagal) ya itna chhota bachcha jo be aql ho unka zabeeha
             jaayez nahi aur agar chhota bachcha zabah ko samajhta ho aur us par qudrat rakhta ho to uska
              zabeeha halaal hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <p className="contentSection_title--content">
            (2) zabah karne wala muslim ho aur murtad ka zabeeha haraam o murdaar hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            raafzi tabarraai wahabai devbandi, wahabi gair muqallid, qaadiyaani chakdali neechri in sab ke 
            zabeehe mahaz najis o mudaar haraam e qat’ee hain agarcheh laakh baar name ilaahi len aur kaise 
            hi muttaqi parhezgaar bante hon keh ye sab murtddeen hain (Ahkam e shari’at)
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            (3) Allah azza o jalla ke name ke saath zabah karna Zabah karte waqt Allah تعالى ke namo me se koi 
            name zikr kare Jaanwar halaal ho jaayega yahi zaroori nahi keh lafz e allah hi zabaan se kahe.
             <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            tanha name hi zikr kare ya name ke saath sifat bhi zikr kare dono soorat me Jaanwar halaal ho jaata hai maslan:
الله اكبر

الله اعظم Ya sirf الله

Ya رحمن Wagairah kahe aur isi tarah

سبحن الله

الحمدلله Padhne se bhi halaal ho jaayega <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            allah azza o jalla ka name arbi ke siwa dosri zaban me liya jab bhi halaal ho jaayega <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            (4) khud zabah karne wala allah azza o jalla ka name apni zaban se kehe Agar ye khaamoosh raha
             dosro ne name liya aur use yaad bhi tha bhoola na tha to Jaanwar haraam hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            agar name lena bhool gaya to Jaanwar halaal hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            allah azza o jalla ka name waqt e zabah lene me itni aawaz zaroori hai keh agar zabah karne wala bahra
             na ho aur shor o gul na ho to  woh khud sun sake to agar itni bhi aawaz na hui to Jaanwar haraam ho
              gaya.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            ba’z log Jaanwar zabah karte waqt aawaz se bismillahi allahu akbar nahi kahte aur unse poochha 
            jaaye keh waqt e zabah Bismillah nahi padhi to kahte hain keh main ne dil mem padh liya is soorat
             me bhi Jaanwar halaal na hua.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            bihtar ye hai keh zabah karne wala itni aawaz se Bismillah allahu akbar kahe keh aas paas ke log sune
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            ba’z log chhuri par Bismillah allahu akbar padh kar dam (phook) kar ke dosre ko zabah ke liye de dete 
            hain aur  woh dosra zabah karta hai is soorat mem agar is dosre ne waqt e zabah Bismillah nahi padhi to
             Jaanwar haraam ho jaayega.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            (5) naam e ilaahi lene se zabah par name lena maqsood ho aur agar dosre maqsad ke liye Bismillah 
            padhin aur saath lage zabah kar diya aur us par Bismillah padhna maqsood nahi to Jaanwar halaal na
             hua Maslan chhink aai aur is par alahamdulillah kaha aur Jaanwar zabah kar diaya us par name ilaahi
              zikr karna maqsood nahi tha Jaanwar halaal na hua <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            (6) zabah ke waqt gair e khuda ka name na le <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <p className="contentSection_title--content">
            (7) jis Jaanwar ko zabah kiya jaaye  woh waqt e zabah zindah ho agarche uski hayaat ka thoda hi hissa 
            baaqi rah gaya ho. Zabah ke ba’d khoon nikana ya Jaanwar me harkat paida hona yun zaroori hai keh is
             se uska zindah hona maloom hota hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            bakri zabah ki aur khoon nikla magar us me harkat paida na hui agar  woh aisa khoon hai jaise zindah
             Jaanwar me hota hai halaal hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            zabah har us chiz se kar sakte hain jo ragen kaat de aur khoon baha de ye zaroori nahi keh chhuri
             hi se zabah kare <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            kund chhuri (jis chhuri me dhaar na ho) se zabah karna makrooh hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            mustahab ye hai keh Jaanwar ko litane se pahle chhuri tez kar le aur litane ke ba’d chhuri tez karna 
            makrooh hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            is tarah zabah karna keh chhuri haraam magz tak pahunch jaaye ya sar kat kar juda ho jaaye makrooh hai 
            magar zabeeha khaya jaayega yani karahat us fe’l me hai na keh zabeeha me <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Aam logo me ye mashhoor hai keh zabah karne me agar sar juda ho jaaye to us sar ka khana makrooh hai
             ye kutb e fiqah me nazar se nahi guzra balkeh fuqha ka ye irshad keh zabeeha khaya jaayega us se yahi
              saabit hota hai keh sar bhi khaya jaayega <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            ba’z jagah ye mashhoor hai keh zabah karne me agar sar juda ho jaaye to Jaanwar hi haraam ho jaata
             hai is ki bhi koi asl nahi balkeh  woh jaanwar bhi halaal hai
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            har  woh fe’l jis se Jaanwar ko bila faaidah takleef pahunche makrooh hai maslan Jaanwar me abhi hayaat
             baaqi ho thanda hone se pahle uski khaal utaarna us ke a’za kaatna ya zabah se pahle uske sar ko kheenchna ke ragen zaahir ho jaayen ya gardan ko todna <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Jaanwar ko gardan ki taraf se zabah karna makrooh hai balkeh uski ba’z sooraton me Jaanwar haraam 
            ho jaayega <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            sunnat ye hai keh zabah ke waqt Jaanwar ka munh qibla ko kiya jaaye aur aisa na karna makrooh hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            zabah me aurat ka wahi hukm hai jo mard ka hai, yani muslima ya kitabiya aurat ka zabeeha halaal ha
             aur mushrika o murtaddah ka zabeeha haraam hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            awam me mashhoor hai keh aurat zabah nahi kar sakti be asl hai . Aurat Bhi zabah kar sakti hai.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            zabah karne me qasdan (jaan boojh kar) Bismillah na kahi Jaanwar haraam hai aur agar bhool kar aisa 
            hua is soorat me Jaanwar halaal hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Bismillah ki ha (ه) ko zaahir karna chahiye agar zaahir na ki jaaye jaisa keh ba’z awam iska talaffuz
             is tarah karte hain keh ha (ه) zaahir nahi hoti aur maqsood allah ka name zikr karna hai to Jaanwar
              halaal hai aur agar ye maqsood na ho aur ha (ه) choodna hi maqsood ho to halaal nahi
               <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Mustahab ye hai keh zabah ke waqt بسم الله الله اكبر

kahe yani بسم الله الله اكبر ke darmiyan waao (و) na laaye aur agar بسم الله والله اكبر waao (و) ke saath kaha
 to Jaanwar is soorat me bhi halaal hoga magar ba’z ulama is tarah kahne ko makrooh batate hain <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Bismillah kisi dosre maqsad se padhi aur Jaanwar zabah kar diya to Jaanwar halaal nahi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            khud zabah karne wale ko Bismillah kahna zaroori hai dosre ka kahna iske kahne ke qaaim maqaam nahi
             yani dosre ke Bismillah padhne se Jaanwar halaal na hoga jabkeh zaabih ne qasdan (jaan boojh kar) tark kiya ho <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            2 shakhso ne zabah kiya to dono ka padhna zaroori hai 1 ne qasdan (jaan boojh kar) tark kiya to
             Jaanwar haraam Mo’een e zaabih se yahi murad hai keh zabah karne me uska mu’een ho yani dono ne
              milkar zabah kiya ho dono ne chhuri pheri ho maslan zaabih kamzor hai keh uski tanha quwwat kaam 
              nahi degi, dosre ne shairkat ki dono ne milkar chhuri chalaai . Agar dosra shakhs Jaanwar ko faqat
               pakde huye hai to ye mo’een e zaabih nahi iske padhne na padhne ko kuchh dakhal nahi ye agar padhta
                hai to iska maqsad ye ho sakta hai keh zaabih ko Bismillah yaad aa jaaye aur padh le 
                <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Bismillah kahne aur zabah karne ke darmiyan taweel faasla na ho aur majlis badalne na paaye agar
             majlis badal gayi aur amal kaseer beech me paaya gaya to halaal na hua . 1 luqma khaaya ya zara
               sa paani piya chhuri tez ki ye amal e qaleel hai Jaanwar is soorat me halaal hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            bakri zabah ke liye litaai thi Bismillah kah kar zabah karna chahta tha keh  woh uth kar bhaag gayi 
            phir use pakad kar laaya aur litaya to ab phir Bismillah padhe pahle ka padhna khatm ho gaya
             <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            gaaye ya bakri zabah ki aur uske pet me bachcha nikla agar  woh zindah hai zabah kar diya jaaye halaal
             ho jaayega aur mara hua hai to haraam hai uski maan ka zabah karna uske halaal hone ke liye kaafi
              nahi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            billi ne murgi ka sar kaat liya aur  woh abhi zindah hai phadak rahi hai zabah nahi ki jaa sakti 
            <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Jaanwar ko din me zabah karna bihtar hai aur mustahab ye hai keh zabah se pahle chhuri tez kar le
             <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            kund chhuri ya aisi chizo se zabah karne se bache jis se Jaanwar ko eeza ho <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            raat me zabah karna makrooh hai <span className="referenceTag">(Bahar e shari’at)</span> 
            </p>
            <h3 className="contentSection_subtitle">GOSHT KA BAYAAN</h3>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ka gosht khud bhi kha sakta hai aur dosre shakhs gani ya faqeer ko bhi de sakta hai khila 
            sakta hai balkeh us me se kuchh kha lena Qurbaani karne wale ke liye mustahab hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            bihtar ye hai keh gosht ke 3 hisse kare 1 hissa fuqra ke liye aur 1 hissa dost o ahbaab ke liye aur
             1 hissa apne ghar walo ke liye <span className="referenceTag">(Bahar e shari’at)</span> 
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            1 tihaai se kam sadqa na kare Aur kul ko sadqa kar dena bhi jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            kul ghar me rakh le ye bhi jaayez hai 3 din se zaaid apne ghar walo ke khane ke liye rakh lena bhi
             jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            agar us shakhs ke ahl o ayaal bahut hon aur saahib e us’at nahi hai to bihtar ye hai keh saara gosht
             apne baal bachcho ke liye hi rakh chhode <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            qurbani ka gosht kafir ko na de keh yahan kuffar harbi hain <span className="referenceTag">(Bahar e shari’at)</span>

Yani yahan ke kaafiro ko gosht dena jaayez nahi

(Fatawa razviyyah jild 8 safah 467)
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            ojhdi, aant, wagairah khane ki chiz nahi use dafan kar den aur agar koi kafir le jaaye ya kafir ko
             dedi jaaye to harj nahi (Maakhooz az Fatawa razviyyah )
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani agar mannat ki hai to uska gosht na khud kha sakta hai aur na agniya ko khila sakta hai
             balkeh usko sadqa kar dena wajib hai  woh mannat maanne wala faqeer ho ya gani dono ka ek hi hukm hai
              keh khud nahi kha sakta na gani ko khila sakta hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            maiyyit ki taraf se Qurbaani ki to uske gosht ka bhi wahi hukm hai keh khud khaye dost o ahbaab ko de
             faqeero ko de ye zaroori nahi keh saara gosht faqeero hi ko de kiyon keh gosht uski milk hai ye sab 
             kuchh kar sakta hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            agar maiyyit ne kah diya hai keh meri taraf se Qurbaani kar dena to is se na khaye balkeh kul gosht
             sadqa kar de <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ke gosht ko apni zaat ke liye bechna jaayez nahi aur agar bech diya to uski qeemat sadqa
             kar dena wajib hai
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ka gosht devbandi wahabi gair muqallid wagiarah ko dena jaayez nahi.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            ba’z log kafir qassab se gosht buti karwate hain to isme ye ihteyaat bahut zaroori hai keh kisi 
            waqt bhi gosht musalman ki nazro se gaaib na ho.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            agar gosht musalman ki nazro se gaaib ho kar kafir ke qabze me ho gaya to us gosht ka khana jaayez nahi.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            devbandi wahabi wagairah badmazhab jinki badmazhabi hadd e kufr ko pahunch gayi ho us ne Jaanwar
             zabah kiya to Qurbaani na hui aur gosht bhi haraam ho gaya.
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            shirkat me gaaye ki Qurbaani hui to zaroor hai keh gosht wazan kar ke taqseem kiya jaaye, andazah se 
            taqseem na ho kiyon keh ho sakta hai keh, kisi ko ziyadah ya kam mile aur ye naajaayez hai, yahan ye
             khayal na kiya jaaye keh kam o besh hoga to har ek isko dosre ke liye jaayez kar dega kah dega keh 
             agar kisi ko zaaid pahunch gaya to mu’aaf kiya keh yahan adam e jawaz haqq e shara hai aur unko is 
             ke mu’aaf karne ka haq nahi <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            yahan ye ho sakta hai keh saaton shareek milkar kisi aise shakhs ko jo is Jaanwar me shareek nahi hai
             kul gosht ka maalik bana kar qabza deden phir  woh shakhs un saaton ko apni taraf se gosht jis qadar
              chahe dede to is soorat me kam ya ziyadah hone me harj nahi, ek soorat ye bhi hai keh kaleji paaye 
              wagairah bhi gosht me shaamil kar den aur andazah se shuraka me taqseem kar den durr e mukhtaar me 
              hai ويقسم اللحم وزنا لا جزافا الا اذا ضم معه من الاكارع او الجلد (على هامش ردالمحتار ج 5 ص 223) 
            </p>
            <h3 className="contentSection_subtitle">HALAAL JAANWAR KE SAB AJZA HALAAL HAIN MAGAR KUCHH AJZA
             HARAAM YA MAMNOO YA MAKROOH HAIN</h3>
            <p className="contentSection_title--content">
            (1) ragon ka khoon.
            </p>
            <p className="contentSection_title--content">
            (2) pittah
            </p>
            <p className="contentSection_title--content">
            (3) phunkna
            </p>
            <p className="contentSection_title--content">
            (4) alamat e maadah
            </p>
            <p className="contentSection_title--content">
            (5) alamat e narr
            </p>
            <p className="contentSection_title--content">
            (6) baize
            </p>
            <p className="contentSection_title--content">
            (7) gudood
            </p>
            <p className="contentSection_title--content">
            (8) haraam magz
            </p>
            <p className="contentSection_title--content">
            (9) gardan ke 2 putthe keh shano tak khinche hote hain
            </p>
            <p className="contentSection_title--content">
            (10) jigar ka khoon
            </p>
            <p className="contentSection_title--content">
            (11) tilli ka khoon
            </p>
            <p className="contentSection_title--content">
            (12) gosht ka khoon keh ba’d e zabah gosht me se nikalta hai
            </p>
            <p className="contentSection_title--content">
            (13) dil ka khoon
            </p>
            <p className="contentSection_title--content">
            (14) pitt yani  woh zard paani keh pitte me hota hai
            </p>
            <p className="contentSection_title--content">
            (15) naak ki rutoobat keh bhed me aksar hoti hai
            </p>
            <p className="contentSection_title--content">
            (16) paakhana ka maqaam
            </p>
            <p className="contentSection_title--content">
            (17) ojhdi
            </p>
            <p className="contentSection_title--content">
            (18) aanten
            </p>
            <p className="contentSection_title--content">
            (19) nutfa
            </p>
            <p className="contentSection_title--content">
            (20)  woh nutfa keh khoon ho gaya
            </p>
            <p className="contentSection_title--content">
            (21)  woh keh gosht ka lothda ho gaya
            </p>
            <p className="contentSection_title--content">
            (22)  woh keh poora Jaanwar ban gaya aur murdah nikla ya be zabah mar gaya
            </p>
            <p className="contentSection_title--content">
            (Fatawa razviyyah jild 8 safah 327)
            </p>  
            <h3 className="contentSection_subtitle">
            EXPORT KE GOSHT KA HUKM
            </h3>
            <p className="contentSection_title--content">
            moqa ki munasabat se zaroori hai keh ham qadr e ijmaal ke saath bayan kar den keh maujoodah
             zamane me EXPORT, EMPORT ke gosht me kiya kiya asbaab e hurmat maujood hain taakeh kam azkam 
              woh log is se parhez kar saken jinhen sirf rizq e halaal hi ki justuju rahti hai aur ijtenaab 
             e haraam ke silsila me  woh log masaaib ka muqabla karne me kotahi nahi karte
            </p>
            <h3 className="contentSection_subtitle">EXPORT KIYE GAYE GOSHT ME ASBAAB E HURMAT KI IJMAALI FAHRIST MULAHAZA HO</h3>
            <p className="contentSection_title--content">
            (1) export kiye gaye gosht me masheeni zabeeha sar e fahrist hai aur ham pahle bayan kar chuke hain keh masheeni 
            zabeeha gair e shar’ee hone ki baais haraam hai
            </p>
            <p className="contentSection_title--content">
            (2) gosht ki beshtar miqdaar yurop, amrika, astrilya ke mamalik se export hoti hai aur wahan ziyadah tar salatar
             house wale aur exporter nasaara hain aur is zamane ke nasaara ka zabeeha haraam hai
            </p>
            <p className="contentSection_title--content">
            (3) export kiya hua gosht castam me pahunchte hi bhejne wale ke qabza o nazar se gaaib ho jaata hai phir 
            kaargo (maal bardaar jahaz) nen bhi gaaib rahta hai castam o kargo ke mulazimeen mazkoorah mamalik me
             mushrekeen o mulhideen o nasaar e zamana hote hain jab keh hukm e shara ye hai keh gosht jab qabza e 
             kafir me pahunch kar nazar e muslim se ek lamha ke liye gaiib ho jaaye to haraam hai lihaza agar export
              kiya hua gosht agarche zabeeha e muslim hi ho aur agarche musalman hi ne bheja ho jab bhi  woh haraam ho
               jaata hai
            </p>
            <p className="contentSection_title--content">
            (4) masheeni zabeeha ke salatar houses un Jaanwaro ka gosht bhi “lahme halaal“ ka lebal laga kar parsal
             kar dete hain jin ke beech sar par ya seena par chhuri chali aur  woh mar gaye aise Jaanwar ki hurmat ijma 
             se saabit hai
            </p>
            <p className="contentSection_title--content">
            Main ne haramain shareefain me zabeeha ke gosht aur emported gosht ki qeemato ka farq bhi maloom kiya to pata 
            chala keh emported gosht ki qeemat 6/7 riyaal fee kilo gram hai jabkeh maqaami zabeeha 25 se 30 riyaal me 1 
            kilo gram dasteyaab hota hai isi liye umooman hotalo aur tour ke matbakhon me emport kiya hua gosht istemaal 
            hota hai haramain tayyibain ke muhtaat awam is gosht se ijtenaab rakhte hain balkeh bahut saare hujjaj e kiram
             aur zaaireen ko bhi ham ne un muqaddas ilaaqo me isi sabab se emported gosht se parhez karte huye paaya zihan
              nasheen kar lijiye keh haraam giza insan me khubs paida karti hai aur haraam giza ki wajah se duaayen maqbool
               nahi hoti ibadaat o ziyaaraat kiya maqbool hongi is liye hujjaj e kiram o zaaireen par laazim hai keh allah 
               o rasool صلى الله تعالى عليه وسلم ke darbaar me pahunch kar gizaai ihteyaat barten agar chand roz gosht
                nahi khaayenge to sihhat par koi bura asar murattab nahi ho jaayega 
                <span className='referenceTag'>
                (Masheeni zabeeha ka hukm safah 13/14/15) 
                </span>
            </p>
            <h3 className='contentSection_subtitle'> CHAMDE KA BAYAAN</h3>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ka chamda aur uski jhol aur rassi aur uske gale me haar dala hai  woh haar in sab chizo ko sadqa 
            kar den <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ke chamde ko khud bhi apne kaam me laa sakta hai yani usko baaqi rakhte huye apne kisi kaam
             me laa sakta hai maslan uski jaa e namaz banaye thaili ya mashkiza dastarkhwan dol wagairah banaye ya
              kitabon ki jildon me lagaaye ye sab kar sakta hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ke chamde ko aisi chizo se badal sakta hai jis ko baaqi rakhte huye us se nafa uthaya jaaye
             jaise kitab Aisi chiz se badal nahi sakta jis ko halaak kar ke nafa haasil kiya jaata ho jaise
              roti gosht sirka rupiya paisa aur agar usne un chizo ko chamde ke ewaz me haasil kiya to un chizo 
              ko sadqa kar de <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            agar Qurbaani ki khaal ko rupiye ke ewaz me becha magar is liye nahi keh usko apni zaat par ya baal
             bachcho par saraf kare balkeh is liye keh use sadqa kar dega to jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            aaj kal aksar log khaal madarsa e deeniyya me diya karte hain aur ba’z martaba wahaan khaal bhejne
             me diqqat hoti hai use bech kar rupiye bhej dete hain ya kayi shakhso ko dena hota hai use bech 
             kar daam un fuqara par taqseem kar dete hain ye bai’e jaayez hai is me harj nahi aur hadees me 
             jo bechne ki mumana’at aai hai us se muraad apne liye bechna hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ka chamda ya gost ya us me ki koi chiz qassab ya zabah karne wale ko uski ujrat me
             nahi de sakta keh usko ujrat me dena bechne hi ke ma’na me hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            qassab ko ujrat me nahi diya balkeh jaise dosre musalamano ko deta hai usko bhi diya aur
             ujrat apne paas se dosri chiz dega to jaayez hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            ba’z log chamde ko bhi gosht ki tarah paka kar khate hain to is me harj nahi keh chamda
             ajza e mamnoo’ah me se nahi hai
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ki khaal masjid o madarsa me is liye dena keh use bech kar masjid o madarsa ke
             masaarif me kharch kiya jaaye maslan imam o muazzin o mulaazimeen ki tankhwah me ya masjid 
             ki tameer wagairah me to is me harj nahi (Makhuz az Fatawa razviyyah wagairah )
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ki khaal khud bech kar masjid me diya to is me bhi harj nahi
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            chunkeh Qurbaani ki khaal ka sadqa karna sadqa e naagilah hai to is me tamleek faqeer
             shart nahi Fatawa razviyyah me hai charm e Qurbaani ka tasadduq aslan wajib nahi ek sadqa 
             e naafila hai is me ishtiraat e tamleek kahan se aaya (jid 8 safah 48) Lihaza Qurbaani ki
              khaal majid o madarsa wagairah me dene me heela e shar’ee ki zaroorat nahi
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            wahabi devbandi gair muqallid wagairah ke madaaris me Qurbaani ki khaal dena jaayez nahi
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Qurbaani ki khaal apne liye becha to uski qeemat ka sadqa karna wajib hai is soorat me bagair 
            heela shar’ee masjid o madarsa wagiarah mem nahi saraf kar sakte.
            </p>

          <h3 className="contentSection_subtitle">YAUM E ARFAH KA ROZA</h3>
            <h4 className="contentSection_subheading">Hadees::</h4>
            <p className="contentSection_title--content">
            Hazrat e abu qatadah رضى الله تعالى عنه se riwayat hai keh rasoolullah صلى الله تعالى عليه وسلم ne
             irahaad farmaya ki arfah ka rozah 1 saal qabl aur 1 saal ba’d ke gunaaho ka kaffar hai
             <span className='referenceTag'>(Muslim shareef :2747 )</span>
            </p>
            <h4 className="contentSection_subheading">Hadees::</h4>
            <p className="contentSection_title--content">
            ummul mumineen siddeeqah رضى الله تعالى عنها se riwayat hai rasoolullah صلى الله تعالى عليه وسلم arfah
             ke rozah ko 1000 din ke barabar batate
             <span className='referenceTag'>(Baihaqi / tibrani)</span>
            </p>
            <h4 className="contentSection_subheading">Hadees::</h4>
            <p className="contentSection_title--content">
            Hazrat e abu hurairah رضى الله تعالى عنه se riwayat hai keh Huzur صلى الله تعالى عليه وسلم ne arfah
             ke din (Arafaat) me rozah rakhne se mana farmaya 
             <span className='referenceTag'>(Abu daaud / nasai)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            hajj karne wale par jo arafaat me hai use arfah ke din ka rozah makrooh hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h3 className='contentSection_subtitle'>ARFAH O EIDAIN WAGAIRAH KI RAATO me SHAB BEDAARI</h3>
            <h4 className="contentSection_subheading">Hadees::</h4>
            <p className="contentSection_title--content">
            Hazrat e abu umamah رضى الله تعالى عنه se riwayat hai keh rasoolullah صلى الله تعالى عليه وسلم farmate
             hain jo eidain ki raato me qiyaam (ibadat) kare uska dil na marega jis din logo ke dil marenge
             <span className='referenceTag'> (Ibn e maajah)</span>
            </p>
            <h4 className="contentSection_subheading">Hadees::</h4>
            <p className="contentSection_title--content">
            Hazrat e ma’aaz bin jabal رضى الله تعالى عنه se riwayat hai farmate hain jo 5 raaton me 
            shab bedaari kare us ke liye jannat wajib hai zulhijja ki aathwen, nauwen, daswen aur eidul 
            fitr ki raat aur sha’ban ki pandrahwe raat yani shab e barat 
            <span className='referenceTag'> (Asbahani)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            eidain aur pandrahwen sha’ban ki raaton aur ramzan ki akheer 10 raato aur zulhijjah ki pahli
             10 raaton me shab bedaari mustahab hai aksar hissa me jaagna bhi shab bedaari hai <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            eidain ki raaton me shab bedaari ye hai keh isha o subah (fajar) dono jamat e oola se hon keh
             sahih hadees me farmaya jis ne isha ki namaz jamat se padhi us ne aadhi raat ibadat ki aur jis 
             ne namaz e fajar jamat se padhi us ne saari raat ibadat ki un raato me agar jaagega to namaz e
              eid o Qurbaani wagairah me diqqat hogi lihaza isi par iktefa kare aur agar in kaamo me farq
               na aaye to jaagna bahut bihtar <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            in raato mem tanha nafl namaz padhna aur tilawat e Quran e majeed aur hadees padhna aur sunna 
            aur durood shareef padhna shab bedaari hai na keh khaali jaagna <span className="referenceTag">(Bahar e shari’at)</span>
            </p>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Bahut se log in raaton me idhar udhar ghoom kar laa yani aur fuzul baaton me poora waqt guzaar 
            dete hain ise shab bedaari nahi kahte balkeh shab bedaari ye hai keh agar zindagi me namazen
             qaza hon to use ada karen ya nafl padhen ya durood o azkaar o wazaaif aur auraad me mashgool 
             rahen, , Allah تعالى hame in raaton ki ta’zeem o takreem ki taufeeq ata farmaye aur in raaton 
             me ziyadah se ziyadah ibadat o riyazat ki taufeeq ata farmaye
             (Aameen)
            </p>
            <h3 className='contentSection_subtitle'>ARFAH KE DIN DUA BEHTAR HAI</h3>
            <h4 className="contentSection_subheading">MASLAH::</h4>
            <p className="contentSection_title--content">
            Hazrat e amr bin shuaib رضى الله تعالى عنه se riwayat hai keh Huzur nabi kareem صلى الله تعالى عليه وسلم ne
             irshad farmaya “bihtar dua arfah ki dua hai ” 
             <span className='referenceTag'> (tirmizi)</span>
            </p>
            <h4 className="contentSection_subheading">Hadees::</h4>
            <p className="contentSection_title--content">
            Hazrat e abdullah bin amr bin aas رضى الله تعالى عنهما se riwayat hai keh 
            Rasoolullah صلى الله تعالى عليه وسلم ne irshad farmaya keh bihtar dua arfah ke din 
            ki dua hai, aur bihtar wazeefah  woh hai jo mera aur ambiya e saabiqeen ka raha hai yani
             ” لَا اِلٰهَ اِلَّا اللّٰهُ وَحْدَهُ لَا شَرِيْكَ لَهُ لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلٰى كُلِّ شَيْئٍ قَدِيْر ”
            </p>
            <h4 className="contentSection_subheading">Note::</h4>
            <p className="contentSection_title--content">YAUM E ARFAH 9 wi ZiLHIJJAH KO KAHTE HAIN
            </p>
    </div>
  )
}

export default EidulAdha